import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';

interface PrintQuoteButtonProps {
  /** 놓이는 자리에 맞춘 크기·폭 — 상세의 버튼 줄이 넘긴다. */
  readonly className?: string;
}

/** 인쇄(견적 설계 §7-10) — 브라우저 인쇄창을 연다. 인쇄 모양은 QuoteDocument 의 print: 변형이 맡는다. */
export const PrintQuoteButton = ({ className }: PrintQuoteButtonProps = {}): ReactElement => (
  <Button type="button" variant="outline" className={className} onClick={() => window.print()}>
    인쇄
  </Button>
);
